import axios from 'axios';

const API_URL = import.meta.env.BASE_URL || 'http://localhost:8080';

const api = axios.create({
  baseURL: API_URL,
});

export interface FAQ {
  id: string;
  question: string;
  answer: string;
}

// Guest is the main guest object, one per token/family
export interface Guest {
  name: string;
  language: string; // de or en

  attending?: boolean;
  message?: string;

  menu?: Record<string, Menu>;
  rsvps: RSVP[];
}

export interface MenuItem {
  id: string;
  description: string;
}

export interface Menu {
  starters: MenuItem[];
  mains: MenuItem[];
  desserts: MenuItem[];
}

export interface RSVPs {
  message: string;
  attending: boolean;
  rsvps: RSVP[];
}

export interface RSVP {
  name: string;
  menu_choice?: MenuChoice;
  attending_ceremony: boolean;
  attending_reception: boolean;
}

// enum
export enum MenuType {
  Adult = 'adult',
  Child = 'child',
  Baby = 'baby',
}

export interface MenuChoice {
  type: MenuType;
  starter: string;
  main: string;
  dessert: string;
  restrictions?: string;
}

export const getGuest = async (token: string): Promise<Guest> => {
  try {
    const response = await api.get<Guest>('/v1/guest', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching guest:', error);
    throw error;
  }
};

export const getFAQs = async (language: string): Promise<FAQ[]> => {
  try {
    const response = await api.get<FAQ[]>(`/v1/faq/${language}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching FAQs:', error);
    throw error;
  }
};

export const updateRSVPs = async (token: string, rsvpData: RSVPs): Promise<RSVP> => {
  try {
    const response = await api.post<RSVP>('/v1/rsvps', rsvpData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating RSVPs:', error);
    throw error;
  }
};

export default api;
